import { getPostNum } from "../../../constant/General";
import { getDateTime } from "../../../utility/dateUtils";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LiveBackground from "../../liveBackground/LiveBackground";
import { drawingV2, slotConfs } from "../../../constant/initDrawing";
import Welcome from "../../live2/Welcome";
import LayoutWrapper from "../../live2/mt/LayoutWrapper";
import RanderSlot from "../../live2/kp/RenderSlot";
import ContentWrapper from "../../live2/tc/ContentWrapper";

const Live3Sc = ({ socket }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isV4 = location.pathname.startsWith("/live-v4/");
    const [result, setResult] = useState(drawingV2);
    const [currentResult, setCurrentResult] = useState(drawingV2);


    useEffect(() => {
        socket.on("sc_result", (payload) => {
            setCurrentResult(payload);
            if (result.results.length === 0 || result.isInited) {
                setResult(payload)
            }
        });

        return () => {
            socket.off("sc_result");
        }
    }, [socket, result]);

    const onStartDraw = (result) => {
        setResult(result)
    }
    const onAfterReleaseCallback = () => setResult(currentResult);

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw} />

    return <LiveBackground result={result} variant={isV4 ? "v4" : undefined}
        preserveInnerBackgrounds={isV4} className="d-flex justify-content-center overflow-hidden mt-2 live2-sc">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(isV4 ? "/live-v4" : "/live-v3")}
        >
            Back
        </button>
        <div>
            {!isV4 && <div className="d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    SC
                </span> {getDateTime(result?.drawAt)}</div>}

            <LayoutWrapper>
                <ContentWrapper
                    shift="day"
                    type="sc"
                    isDef
                    image={isV4 ? require("../../../assets/images/live4/sc/sc-v4.png") : undefined}
                >
                    <div className="d-flex position-relative w-100">
                        <div>
                            <div style={{ height: "650px", position: "relative", marginTop: "18px" }}>
                                <div style={{ paddingLeft: "220px" }} className="d-flex justify-content-center">
                                    <div>
                                        {
                                            result.results.map((num, i) => {
                                                return <div style={{
                                                    height: "120px", marginBottom: "6px", fontSize: "96px",
                                                    scale: ".9",
                                                }}
                                                    className="d-flex justify-content-center align-items-center"
                                                    key={i}>

                                                    <RanderSlot
                                                        currentResult={currentResult}
                                                        index={i}
                                                        rowIndex={i}
                                                        isNight={true}
                                                        onAfterReleaseCallback={onAfterReleaseCallback}
                                                        config={slotConfs}
                                                    />
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="d-flex justify-content-center align-items-center">
                            <div style={{ height: "630px", position: "relative" }}>
                                <div style={{ paddingLeft: "285px" }}
                                    className="d-flex justify-content-center align-items-center">
                                    <div>
                                        {
                                            result.results.map((num, i) => {
                                                return <div
                                                    style={{
                                                        height: "115px",
                                                        marginBottom: "13px",
                                                        color: "#FFFFFF",
                                                        fontSize: "120px"
                                                    }}
                                                    className="d-flex justify-content-center align-items-center"
                                                    key={i}>
                                                    <div className="d-flex justify-content-center align-items-center"
                                                        style={{
                                                            marginRight: "168px"
                                                        }}>{getPostNum(num.number.slice(0, 2))}</div>
                                                    <div
                                                        className="d-flex justify-content-center align-items-center">{getPostNum(num.number.slice(2, 5))}</div>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentWrapper>
            </LayoutWrapper>
        </div>
    </LiveBackground>
}

export default Live3Sc;
